import { OnInit, Component, Input } from '@angular/core';
import { FuseTranslationLoaderService } from 'app/core/services/translation-loader.service';
import { ProjectService } from 'app/main/pages/project/project.service';
import { locale as english } from './translate/en';
import { locale as danish } from './translate/ds';
import { RequestMessageLogs } from 'app/main/model/RequestBase';
import { ResponseBase } from 'app/main/model/ResponseBase';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'vibe-message-log',
  templateUrl: 'message-log.component.html',
  styleUrls: ['./message-log.component.scss']
})
export class MessageLogComponent implements OnInit {
  showSpinner = false;
  @Input() ProjectID: string = null;
  @Input() CustomerID: string = null;
  @Input() MobileNo: string = null;
  @Input() Flag: number = null;
  requestModel: RequestMessageLogs = new RequestMessageLogs();
  messageLogData: any = [];
  displayPagination: boolean;
  pagination: any;
  limitNumber: any;
  constructor(private translationLoader: FuseTranslationLoaderService,
    private projectservice: ProjectService,
    public dialog: MatDialog) {
    this.translationLoader.loadTranslations(english, danish);
  }

  ngOnInit() {
    this.requestModel.Index = 1;
    this.requestModel.Limit = 200;
    this.requestModel.OrderBy = "Date DESC";
    this.requestModel.ProjectId = this.ProjectID ? this.ProjectID : '';
    this.requestModel.CustomerId = this.CustomerID ? this.CustomerID : '';
    this.requestModel.MobileNo = this.MobileNo ? this.MobileNo : '';
    this.requestModel.Flag = this.Flag ? this.Flag : null;
    // this.requestModel.InquiryID = this.InquiryID;
    // this.requestModel.OfferID = this.OfferID;
    this.getCustomerLogs();
  }

  getCustomerLogs() {
    this.showSpinner = true;
    this.projectservice.GetMessageLogs<ResponseBase>(this.requestModel)
      .subscribe({
        next: (response: ResponseBase) => {
          this.showSpinner = false;
          if (response != null && response.result) {
            this.messageLogData = response.result;
            this.pagination = response.pagination;
            this.displayPagination = true;
          }
          else {
            this.messageLogData = [];
            this.displayPagination = false;
          }
        },
        error: err => {
          this.showSpinner = false;
          this.messageLogData = [];
          this.displayPagination = false;
        },
        complete: () => { }
      });
  }

  receivePaginatonEvent(event) {
    this.requestModel.Index = event.pageIndex;
    this.requestModel.Limit = event.pageSize;
    this.limitNumber = event.pageSize;
    this.getCustomerLogs();
  }
}
